import RoutedDialog from 'broker/components/RoutedDialog';
import { RouteKey } from 'broker/enums';
import Content from './Content';

export default function CarrierDialog() {
  return (
    <RoutedDialog ariaLabelId="carrier-modal" routeKey={RouteKey.Carrier} isLocationStateRequired={false}>
      {(props) => <Content {...props} />}
    </RoutedDialog>
  );
}
